<div class="main flex-vertical-center">
    <mat-spinner diameter="24"></mat-spinner>
    <span style="font-size:0.83em">Loading profile, please wait...</span>
</div>